import * as angular from 'angular';

export default class UtilService {
  /**
   * Are all values of `key` in a list true?
   *
   * @param  {array}   list The list of objects
   * @param  {string}  key  The key
   * @return {boolean}
   */
  isTruthyForAllItems(list, key): boolean {
    let areAllTrue = true;

    angular.forEach(list, (item) => {
      if (!item[key]) {
        areAllTrue = false;
      }
    });

    return areAllTrue;
  }

  getCommitmentLabel(plan: any) {
    let selectedOffer = plan.offers.find((offer) => offer.selected);
    let commitmentType =
      selectedOffer?.supportedTerms?.[0]?.commitmentTypes?.[0];

    let commitmentTypes = {
      GROUP: 'Group Commitment',
      DUAL_SOURCE: 'Dual Prime Vendor',
      DUAL: 'Dual Prime Vendor',
      INDIVIDUAL_COMMITMENT: 'Individual Commitment',
    };
    return commitmentTypes[commitmentType];
  }
}
